// extracted by mini-css-extract-plugin
export var cardContainer = "_pc-0";
export var cardHeader = "_pc-2";
export var collapsedState = "_pc-3";
export var dragHandle = "_pc-5";
export var dragHandleIcon = "_pc-6";
export var dragging = "_pc-1";
export var titleArea = "_pc-4";